import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgApexchartsModule } from 'ng-apexcharts';
import { HeaderComponent } from '@shared/component/layout/header/header.component';
import { ParentHeaderComponent } from '@shared/component/layout/parent-header/parent-header.component';
import { SidebarComponent } from '@shared/component/layout/sidebar/sidebar.component';
import { ParentSidebarComponent } from '@shared/component/layout/parent-sidebar/parent-sidebar.component';
import { FooterComponent } from '@shared/component/layout/footer/footer.component';
import { LayoutComponent } from '@shared/component/layout/layout.component';
import { SpinnerComponent } from '@shared/component/layout/spinner/spinner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import { ConstantsService } from '@shared/service/constants.services';
import { AuthComponent } from '@shared/component/auth/auth.component';
import { BreadcrumbComponent } from './component/basic/breadcrumb/breadcrumb.component';
import { CheckboxComponent } from './component/basic/checkbox/checkbox.component';
import { TextFieldComponent } from './component/basic/text-field/text-field.component';
import { AccordionComponent } from './component/basic/accordion/accordion.component';
import { AlertComponent } from './component/basic/alert/alert.component';
import { BadgeComponent } from './component/basic/badge/badge.component';
// import { ChipsComponent } from './component/basic/chips/chips.component';
import { DatePickerComponent } from './component/basic/date-picker/date-picker.component';
import { DropdownComponent } from './component/basic/dropdown/dropdown.component';
import { EmptyStateComponent } from './component/basic/empty-state/empty-state.component';
// import { FileUploadComponent } from './component/basic/file-upload/file-upload.component';
// import { ImageComponent } from './component/basic/image/image.component';
// import { LinkComponent } from './component/basic/link/link.component';
import { ModalComponent } from './component/basic/modal/modal.component';
// import { PaginationComponent } from './component/basic/pagination/pagination.component';
// import { ProgressComponent } from './component/basic/progress/progress.component';
import { RadioButtonComponent } from './component/basic/radio-button/radio-button.component';
import { TabComponent } from './component/basic/tab/tab.component';
import { TextAreaComponent } from './component/basic/text-area/text-area.component';
import { TextEditorComponent } from './component/basic/text-editor/text-editor.component';
// import { TimerComponent } from './component/basic/timer/timer.component';
import { ToastrComponent } from './component/basic/toastr/toastr.component';
import { ToggleComponent } from './component/basic/toggle/toggle.component';
import { TooltipComponent } from './component/basic/tooltip/tooltip.component';
import { DataTableComponent } from './component/advance/data-table/data-table.component';
import { MessageComponent } from './component/advance/message/message.component';
import { DashboardMomentComponent } from './component/advance/dashboard-moment/dashboard-moment.component';
import { ProfileFormComponent } from './component/advance/profile-information/profile-information.component';
import { KidsProfileFormComponent } from './component/advance/kidsprofile-information/kidsprofile-information.component';
// import { FilterDatatableComponent } from './component/advance/filter-datatable/filter-datatable.component';
// import { BarComponent } from './component/advance/graph/bar/bar.component';
// import { BarometerComponent } from './component/advance/graph/barometer/barometer.component';
// import { DonutComponent } from './component/advance/graph/donut/donut.component';
// import { BasicTreemapComponent } from './component/advance/graph/basic-treemap/basic-treemap.component';
// import { ScatterComponent } from './component/advance/graph/scatter/scatter.component';
// import { StackAreaComponent } from './component/advance/graph/stack-area/stack-area.component';
// import { StackBarComponent } from './component/advance/graph/stack-bar/stack-bar.component';
// import { TrendAreaComponent } from './component/advance/graph/trend-area/trend-area.component';
// import { TrendLineComponent } from './component/advance/graph/trend-line/trend-line.component';
// import { LagendComponent } from './component/advance/lagend/lagend.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxEditorModule } from 'ngx-editor';
import { ButtonComponent } from './component/basic/button/button.component';
import { OptionButtonComponent } from './component/basic/option-button/option-button.component';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { MultiDropdownComponent } from './component/basic/multi-dropdown/multi-dropdown.component';
// import { MyActionItemComponent } from './component/advance/my-action-item/my-action-item.component';
// import { StatCardComponent } from './component/advance/stat-card/stat-card.component';
// import { StatusBarComponent } from './component/advance/status-bar/status-bar.component';
// import { TrandingComponent } from './component/advance/tranding/tranding.component';
// import { RankComponent } from './component/advance/rank/rank.component';
// import { SummaryTableComponent } from './component/advance/summary-table/summary-table.component';
// import { TreeMapComponent } from './component/advance/tree-map/tree-map.component';
// import { CountCardComponent } from './component/advance/count-card/count-card.component';
// import { AdvanceSearchComponent } from './component/advance/advance-search/advance-search.component';
import { TooltipModule } from 'primeng/tooltip';
// import { CustomColumnComponent } from './component/advance/custom-column/custom-column.component';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
// import { FileUploaderComponent } from './component/advance/file-uploader/file-uploader.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { ImageModalComponent } from './component/advance/file-uploader/image-modal/image-modal.component';
// import { CustomDateTimePickerComponent } from './component/basic/custom-datetime-picker/custom-datetime-picker.component';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import {PaginatorModule} from 'primeng/paginator';
// import { RadioDropdownComponent } from './radio-dropdown/radio-dropdown.component';
import {MultiSelectModule} from 'primeng/multiselect';
import { FileShowerComponent } from './component/advance/file-shower/file-shower.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SidePanelComponent } from './component/advance/side-panel/side-panel.component';
import { CustomDateTimePickerComponent } from './component/basic/custom-datetime-picker/custom-datetime-picker.component';
import { FileUploadComponent } from './component/basic/file-upload/file-upload.component';
import { AdvanceSearchComponent } from './component/advance/advance-search/advance-search.component';
import { NotificationItemComponent } from './component/advance/notification-item/notification-item.component';
import { StatusBarComponent } from './component/advance/status-bar/status-bar.component';
import { ConstantsService } from './service/constants.services';
// import { PtwComponent } from './component/advance/ptw/ptw.component';
// import { NotificationItemComponent } from './component/advance/notification-item/notification-item.component';



@NgModule({
  declarations: [
    //Layout
    HeaderComponent,
    ParentHeaderComponent,
    SidebarComponent,
    ParentSidebarComponent,
    FooterComponent,
    LayoutComponent,
    SpinnerComponent,
    AuthComponent,

    //Basic Component
    AccordionComponent,
    AlertComponent,
    BadgeComponent,
    BreadcrumbComponent,
    ButtonComponent,
    OptionButtonComponent,
    CheckboxComponent,
    // ChipsComponent,
    DatePickerComponent,
    DropdownComponent,
    EmptyStateComponent,
    FileUploadComponent,
    // ImageComponent,
    // LinkComponent,
    ModalComponent,
    // PaginationComponent,
    // ProgressComponent,
    RadioButtonComponent,
    TabComponent,
    TextAreaComponent,
    TextEditorComponent,
    TextFieldComponent,
    // TimerComponent,
    ToastrComponent,
    ToggleComponent,
    TooltipComponent,
    MultiDropdownComponent,

    //Advance Component
    NotificationItemComponent,
    DataTableComponent,
    MessageComponent,
    DashboardMomentComponent,
    ProfileFormComponent,
    KidsProfileFormComponent,
    SidePanelComponent,
    CustomDateTimePickerComponent,
    FileUploadComponent,
    AdvanceSearchComponent,
    NotificationItemComponent,
    StatusBarComponent,
    // FilterDatatableComponent,
    // MyActionItemComponent,
    // StatCardComponent,
    StatusBarComponent,
    // TrandingComponent,
    // RankComponent,
    // SummaryTableComponent,
    // TreeMapComponent,
    // CountCardComponent,
    AdvanceSearchComponent,
    // CustomColumnComponent,
    //Graph Component
    // BarComponent,
    // BarometerComponent,
    // DonutComponent,
    // ScatterComponent,
    // StackAreaComponent,
    // StackBarComponent,
    // TrendAreaComponent,
    // TrendLineComponent,
    // LagendComponent,
    // BasicTreemapComponent,
    // FileUploaderComponent,
    // ImageModalComponent,
    CustomDateTimePickerComponent,
    // RadioDropdownComponent,
    FileShowerComponent,
    // PtwComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgApexchartsModule,
    RouterModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxEditorModule,

    //PrimeNG
    ButtonModule,
    TableModule,
    TooltipModule,
    CheckboxModule,
    CalendarModule,
    MatIconModule,
    MatDialogModule,
    MatSnackBarModule,
    DropdownModule,
    ButtonModule,
    InputTextModule,
    InputGroupModule,
    PaginatorModule,
    InputSwitchModule,
    MultiSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule,
    MatTooltipModule
  ],
  providers: [ConstantsService],
  exports: [
    //Layout
    SpinnerComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDateTimePickerComponent,
    RouterModule,
    SpinnerComponent,
    TooltipModule,
    CheckboxModule,
    CalendarModule,
    InputSwitchModule,
    NgSelectModule,

    //Basic Component
    AccordionComponent,
    AlertComponent,
    BadgeComponent,
    BreadcrumbComponent,
    ButtonComponent,
    OptionButtonComponent,
    CheckboxComponent,
    // ChipsComponent,
    DatePickerComponent,
    DropdownComponent,
    EmptyStateComponent,
    FileUploadComponent,
    // ImageComponent,
    // LinkComponent,
    ModalComponent,
    // PaginationComponent,
    // ProgressComponent,
    RadioButtonComponent,
    TabComponent,
    TextAreaComponent,
    TextEditorComponent,
    TextFieldComponent,
    // TimerComponent,
    ToastrComponent,
    ToggleComponent,
    TooltipComponent,
    MultiDropdownComponent,
    DropdownModule,

    //Advance Component
    NotificationItemComponent,
    SidePanelComponent,
    DataTableComponent,
    MessageComponent,
    DashboardMomentComponent,
    ProfileFormComponent,
    KidsProfileFormComponent,
    // FilterDatatableComponent,
    // MyActionItemComponent,
    // StatCardComponent,
    StatusBarComponent,
    // TrandingComponent,
    // RankComponent,
    // SummaryTableComponent,
    // TreeMapComponent,
    // CountCardComponent,
    AdvanceSearchComponent,
    // CustomColumnComponent,

    //Graph Component
    // BarComponent,
    // BarometerComponent,
    // DonutComponent,
    // ScatterComponent,
    // StackAreaComponent,
    // StackBarComponent,
    // TrendAreaComponent,
    // TrendLineComponent,
    // LagendComponent,
    // BasicTreemapComponent,
    // FileUploaderComponent,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule,
    MatTooltipModule,
    // RadioDropdownComponent,
    FileShowerComponent,
    // PtwComponent
  ]
})
export class SharedModule { }
